export const suggest_app_dialog_title = "Suggest an app"
export const suggest_app_dialog_description =
  "If you can't find a particular app, feel free to suggest by sending us the app name."
